import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var ConfirmationModalFooter = function ConfirmationModalFooter(_ref) {
  var confirmText = _ref.confirmText,
    cancelText = _ref.cancelText,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full items-center gap-4"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("text-white rounded p-3 text-sm font-bold w-56 outline-none border-0 cursor-pointer", variant === "danger" ? "bg-danger-old" : "bg-primary"),
    onClick: function onClick() {
      return onConfirm();
    }
  }, confirmText), /*#__PURE__*/React.createElement("button", {
    className: "border border-solid rounded border-primary text-primary p-3 text-sm font-bold w-56 bg-white outline-none cursor-pointer",
    onClick: function onClick() {
      return onCancel();
    }
  }, cancelText)));
};
export default ConfirmationModalFooter;